import { itdrApi } from "./api";

const adapIdMFAService = {

  async getadapidMfaOverview() {
    const response = await itdrApi.get('/authentication-stats');
    // console.log("getinfo",response.data)
    return response;
  },
  
};

export default adapIdMFAService;